import React from 'react';
import HeroSection from "../../components/home/HeroSection";
import QuoteForm from "../../components/home/QuoteForm";
import ClientsSection from "../../components/home/ClientsSection";
import AboutUs4 from "../../components/about/AboutUs4";
import Aboutus5 from "../../components/about/Aboutus5";
import AboutUs6 from "../../components/about/AboutUs6";
import Aboutus7 from "../../components/about/Aboutus7";
import Aboutus8 from "../../components/about/Aboutus8";
import Aboutus9 from "../../components/about/Aboutus9";
import IndustriesSection from "../../components/home/IndustriesSection";
import SoftwaresSection from "../../components/home/SoftwaresSection";
import AwardsSection from "../../components/home/AwardsSection";
import FAQSection from "../../components/home/FAQSection";
import BlogsSection from "../../components/home/BlogsSection";
import ContactSection from "../../components/home/ContactSection";

const AboutUs = () => {
    return (
        <div className="about-us-page">
            <HeroSection 
                overline="About us Scan to BIM Service Company"
                title={
                    <>
                        Creative Minds, Engineering World-Class <span className="text-primary">Scan-to-BIM and Architectural Solutions</span>
                    </>
                }
                buttonText="Request Quote"
                contentMaxWidth="1200px"
            />
            <QuoteForm customStyle={{ marginTop: '-65px' }} />
            <ClientsSection />
            <AboutUs4 />
            <Aboutus5 />
            <AboutUs6 />
            <Aboutus7 />
            <Aboutus8 />
            <Aboutus9 />
            <IndustriesSection />
            <SoftwaresSection />
            <AwardsSection />
            <FAQSection />
            <BlogsSection />
            <ContactSection />

        </div>
    );
};

export default AboutUs;
